import { arrayToPrefixedUrlQuery, getLanguageCode } from '../utilities';

export default class PilsClient
{
    constructor()
    {
        let languageCode = getLanguageCode();

        this._uri = '/api-customer-pils-' + languageCode;
    }

    get uri()
    {
        return this._uri;
    }

    fetchQtyOnLists(productNumbers)
    {
        return fetch(this._uri + '?' + arrayToPrefixedUrlQuery(productNumbers, 'productNumbers'), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
